import React from "react";
import {useCurrentRefinements, useHits, useQueryRules} from "react-instantsearch";
import "./Banner.scss";


const Banner = ({props, listingBannerConfig}) => {

    const { hits } = useHits(props);
    const { items } = useCurrentRefinements(props);

    const listingBannerData = listingBannerConfig.listingbannerData[0];
    const configUsedRefinment = listingBannerData.usedRefinment;
    const configHeadline = listingBannerData.headline;
    const configText = listingBannerData.text;

    const refinmentWasUsed = items.some(item =>
        item.attribute === configUsedRefinment
    );

    const displayListingBanner = hits.length > 0 && refinmentWasUsed;

    return displayListingBanner ? (
        <div id="search-listing-banner" className="search-listing-banner--content">
            <div class="search-listing-banner--content-headline">{configHeadline}</div>
            <div class="search-listing-banner--content-text">{configText.split('\n').map((line, index) => (
                <React.Fragment key={index}>
                    {line}
                    <br />
                </React.Fragment>
            ))}</div>
        </div>

    ) : null;
}
export default Banner;
